module.exports = __webpack_public_path__ + "media/images/betSponsor__externalLink-5b33174af87cd4783e6209742b6e990c.png";